import axios from 'axios';

const METHODS_REQUIRING_CSRF = new Set(['post', 'put', 'patch', 'delete']);

// Relative URLs and URLs matching the current host are same-origin.
// Absolute URLs pointing to a different host are cross-origin
// and must not receive the CSRF token.
// On parse errors we default to false (cross-origin) to avoid leaking the token.
const isSameOrigin = (url) => {
  if (!url) return true;

  try {
    const { origin } = new URL(url, globalThis.location.origin);
    return origin === globalThis.location.origin;
  } catch {
    return false;
  }
};

// Read the CSRF token fresh on each request to handle token rotation
// (e.g., after Devise sign-in which may regenerate the token).
axios.interceptors.request.use((config) => {
  if (!METHODS_REQUIRING_CSRF.has(config.method)) return config;
  if (!isSameOrigin(axios.getUri(config))) return config;

  const token = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute('content');

  if (!token) return config;

  return {
    ...config,
    headers: {
      ...config.headers,
      'X-CSRF-Token': token,
    },
  };
});
